import { Origin } from "./Origin"

describe('Create Origin Entity', () => {
    it('Should be able to create a new origin', () => {
        const origin = Origin.create({
            name: 'Test'
        })

        expect(origin).toBeTruthy()
    })
})